import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {Divider, Grid, List, ListItem, Snackbar, Typography} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import {BASE_URL_MESSENGER_API, URL_CONTACT_AVATAR, URL_GROUP_AVATAR} from "../../Const";
import {TimeUtil} from "../../utils/TimeUtil";
import {ImageLoader} from "./ImageLoader";
import {DialogRepository} from "../../Repository/messenger/DialogRepository";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const DialogComponent = () => {
    const navigate = useNavigate();
    const [channelList, setChannelList] = useState([]);
    const [snackbar, setSnackbar] = useState({open: false, message: "", type: "success"});

    useEffect(() => {
        const token = localStorage.getItem("pwa_messenger_token");
        if (!token) {
            navigate("/messenger/verify");
        } else {
            const cached = DialogRepository.getAll();
            if (cached?.length) {
                setChannelList(cached);
            }
            fetchChannels(token);
        }
    }, []);

    const fetchChannels = (token) => {
        fetch(BASE_URL_MESSENGER_API + "dialogs", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
            .then(res => res.json())
            .then(res => {
                if (res.code === "200") {
                    DialogRepository.saveDialogs(res.data)
                    setChannelList(res.data);
                }
            })
            .catch(err => {
                console.log("Fetch error", err);
            });
    };

    const handleSnackbarClose = () => {
        setSnackbar(prev => ({...prev, open: false}));
    };

    return (
        <div style={{ height: '100%', overflowY: 'auto' }}>


        <List style={{padding: 0, margin: 0}}>
            {channelList.map(item => {
                const contact = item.contact;
                const group = item.group;

                if (!contact && !group) return null;

                const isGroup = !!group;
                const name = isGroup ? group.title : (contact.name || contact.phone);
                const username = isGroup ? `@${group.username}` : `@${contact.user_name}`;
                const avatarUrl = isGroup
                    ? URL_GROUP_AVATAR + group.avatar
                    : URL_CONTACT_AVATAR + contact.avatar;
                const isOnline = contact?.is_online === 1;
                const lastSeenText = isGroup
                    ? ""
                    : isOnline
                        ? "آنلاین"
                        : `آخرین بازدید: ${TimeUtil.convertTimestampTojalali(contact?.last_seen)}`;

                let lastMessageText = "";
                try {
                    const content = JSON.parse(item.last_message?.content || "{}");
                    lastMessageText = content?.text?.text || content?.caption?.text || "[پیام ناشناخته]";
                } catch (e) {
                    lastMessageText = "[نامعتبر]";
                }

                return (
                    <ListItem
                        key={item.id}
                        component={Link}
                        to={`/messenger/chat?chat_id=${item.chat_id}`}
                        style={{ paddingLeft: 8, paddingRight: 8 }}
                    >
                        <Grid container spacing={1} style={{ direction: 'rtl', textAlign: 'right', margin: 0 }}>
                            {/* Avatar */}
                            <Grid item xs={3} sm={2}>
                                <div style={{
                                    border: isOnline ? '2px solid #4CAF50' : '2px solid transparent',
                                    borderRadius: '50%',
                                    width: 56,
                                    height: 56,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxSizing: 'border-box',
                                    margin: 'auto'
                                }}>
                                    <ImageLoader url={avatarUrl} width={52} height={52} style={{ borderRadius: '50%' }} />
                                </div>
                            </Grid>

                            {/* Name, username, last seen */}
                            <Grid item xs={9} sm={7}>
                                <Typography style={{
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                    color: '#212121',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    {name}
                                    {!isGroup && isOnline &&
                                    <span style={{ color: 'green', fontSize: 10, marginRight: 6 }}>●</span>}
                                </Typography>
                                <Typography style={{
                                    fontSize: 12,
                                    color: '#757575',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {username}
                                </Typography>
                                {!isGroup && (
                                    <Typography style={{ fontSize: 12, color: '#B0BEC5' }}>
                                        {lastSeenText}
                                    </Typography>
                                )}
                            </Grid>

                            {/* Timestamp and unseen count */}
                            <Grid item xs={12} sm={3} style={{ textAlign: 'left' }}>
                                <Typography style={{ fontSize: 12, color: '#90A4AE' }}>
                                    {TimeUtil.convertTimestampTojalali(item.last_message?.created_at_sender / 1000)}
                                </Typography>
                                {item.unseen_count > 0 && (
                                    <div style={{
                                        backgroundColor: '#FF5252',
                                        color: 'white',
                                        borderRadius: 12,
                                        fontSize: 10,
                                        padding: '2px 6px',
                                        display: 'inline-block',
                                        marginTop: 4
                                    }}>
                                        {item.unseen_count}
                                    </div>
                                )}
                            </Grid>

                            {/* Last message preview */}
                            <Grid item xs={12}>
                                <Typography style={{
                                    fontSize: 13,
                                    color: '#424242',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    paddingRight: 8
                                }}>
                                    {lastMessageText}
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider light />
                            </Grid>
                        </Grid>
                    </ListItem>
                );
            })}

        </List>

            <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleSnackbarClose}>
                <Alert onClose={handleSnackbarClose} severity={snackbar.type} sx={{width: '100%'}}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

        </div>
    );
};
